import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from '@/features/auth';
import { userReducer } from '@/entities/user';
import { sidebarReducer } from '@/features/sidebar';
import { notificationReducer } from '@/entities/notification';
import statisticsReducer from '@/entities/statistics/model/statisticsSlice';

// Slices добавляются по мере миграции страниц на новый стек.
// По образцу mcms-front/src/app/store.ts, но только то, что реально нужно
// для нашего API Serious.
export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    sidebar: sidebarReducer,
    notifications: notificationReducer,
    statistics: statisticsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
